import { CLASS_NAMES, SELECTORS } from '@bs/constants';
import { MessageBus } from '@bs/utils';

/**
 * A class for the HomeEmailBlock module
 */
export default class HomeEmailBlock extends MessageBus {
  /**
   * Constructor function of the HomeEmailBlock class. Must receive one arguments, a DOM
   * node representing a delivery ticket.
   * @param {HTMLElement} element - REQUIRED - the module's container
   */
  constructor(element) {
    super();
    /**
     * DOM node that is passed into the constructor
     * @property {object} element DOM node that is passed into the constructor
     */
    this.element = element;

    // Initialize the view
    this.init();
  }

  /**
   * Initializes the view by calling the functions to
   * create DOM references, setup event handlers and
   * then create the event listeners
   * @returns {object} HomeEmailBlock A reference to the current instance of the class
   * @chainable
   */
  init() {
    this.cacheDomReferences().setupHandlers().populateSourcePageURL().enable();

    return this;
  }

  /**
   * Cache DOM References
   *
   * Find all necessary DOM elements used in the view and cache them
   * @returns {object} HomeEmailBlock A reference to the current instance of the class
   * @chainable
   */
  cacheDomReferences() {
    this.sourcePageInput = this.element.querySelector(
      SELECTORS.SOURCE_PAGE_URL
    );
    this.emailInput = this.element.querySelector(`
      .${CLASS_NAMES.HOME_EMAIL_BLOCK_EMAIL}`);
    return this;
  }

  /**
   * Bind event handlers with the proper context of `this`.
   * @returns {object} A reference to the current instance of the class
   * @chainable
   */
  setupHandlers() {
    return this;
  }

  /**
   * Create event handlers to enable interaction with view
   * @returns {object} HomeEmailBlock A reference to the current instance of the class
   * @chainable
   */
  enable() {
    if (this.emailInput) {
      this.emailInput.addEventListener('input', () => {
        if (this.emailInput.validity.typeMismatch) {
          this.emailInput.setCustomValidity(
            'Please enter a valid email address (example: name@example.com)'
          );
        } else {
          this.emailInput.setCustomValidity('');
        }
      });

      this.emailInput.addEventListener('invalid', () => {
        if (this.emailInput.validity.typeMismatch) {
          this.emailInput.setCustomValidity(
            'Please enter a valid email address (example: name@example.com)'
          );
        }
      });
    }

    return this;
  }

  /**
   * Populate the hidden Source_Page_URL field
   * @returns {object} HomeEmailBlock A reference to the current instance of the class
   * @chainable
   */
  populateSourcePageURL() {
    if (!this.sourcePageInput) return this;

    let path = window.location.pathname || '/';

    // Keep only alphanumeric, dashes, and slashes
    path = path.replace(/[^a-zA-Z0-9/-]/g, '');

    // Truncate to 255 characters
    if (path.length > 255) {
      path = path.substring(0, 255);
    }

    const el = this.sourcePageInput;
    const prefix = el.id === 'Source_Page_URL_Footer' ? 'footer_' : 'inline_';
    el.value = `${prefix}${path}`;

    return this;
  }
}
